export default __webpack_public_path__ + "static/1-output-d743b9f027c2de577113688a00fc5b28.png";